import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { ACCESS_TOKEN_URL_SEARCH_PARAM, REDIRECT_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';
import { useLocationSearchParameters } from 'utils/hooks/useLocationSearchParameters';
import { useAuth } from 'utils/hooks/useAuth';

export const PublicRoute = (props) => {
  const {
    [ACCESS_TOKEN_URL_SEARCH_PARAM]: accessTokenSearchParam,
    [REDIRECT_URL_SEARCH_PARAM]: redirectToSearchParam,
  } = useLocationSearchParameters();
  const { isAuthenticated } = useAuth();

  if (isAuthenticated && !accessTokenSearchParam) {
    return <Redirect to={redirectToSearchParam || ROUTE_PATH[ROUTE_NAME.FEED]} />;
  }

  return <Route {...props} />;
};
